
let $b68ed25d6bf54029$var$SCORE = 0;
function $b68ed25d6bf54029$var$getScoreDiv() {
    let scoreNode = document.getElementById("score-keeper");
    return scoreNode;
}
function $b68ed25d6bf54029$var$getScoreNode() {
    let scoreDiv = $b68ed25d6bf54029$var$getScoreDiv();
    return scoreDiv.children[0];
}
function $b68ed25d6bf54029$export$6c65d967fa3ec93() {
    let scoreNode = $b68ed25d6bf54029$var$getScoreNode();
    $b68ed25d6bf54029$var$SCORE += 1;
    scoreNode.innerHTML = $b68ed25d6bf54029$var$SCORE;
}
function $b68ed25d6bf54029$export$96d6c2d129a1da1d() {
    let scoreNode = $b68ed25d6bf54029$var$getScoreNode();
    $b68ed25d6bf54029$var$SCORE = 0;
    scoreNode.innerHTML = $b68ed25d6bf54029$var$SCORE;
}



let $8dd2cf8196daece2$var$COLLISION = false;
function $8dd2cf8196daece2$var$animateSnake() {
    if ($8dd2cf8196daece2$var$COLLISION) {
        (0, $b68ed25d6bf54029$export$96d6c2d129a1da1d)();
        (0, $c1aabd7d87053612$export$28c254c05623bf26)();
        (0, $c1aabd7d87053612$export$d13a71bbf24bf677)();
        $8dd2cf8196daece2$var$COLLISION = false;
        return;
    }
    let boundary = (0, $c1aabd7d87053612$export$1e3d33103e479235)();
    let snakeLen = (0, $c1aabd7d87053612$export$74a176e309663b56)();
    let direction = (0, $fe8af8a42c4a74bc$export$fcce7887255d1c69)();
    let SNAKEARRAY = (0, $c1aabd7d87053612$export$be10b7418aab95c7)();
    let head = SNAKEARRAY[SNAKEARRAY.length - 1];
    let headNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(head[0], head[1]);
    let headHTML = headNode.firstChild;
    for(let i = 0; i <= SNAKEARRAY.length - 2; i++){
        let node = $8dd2cf8196daece2$export$8ae20d19fcabfabc(SNAKEARRAY[i][0], SNAKEARRAY[i][1]);
        let nextNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(SNAKEARRAY[i + 1][0], SNAKEARRAY[i + 1][1]);
        SNAKEARRAY[i] = SNAKEARRAY[i + 1];
        let nodeChild;
        if (node.firstChild != null) nodeChild = node.firstChild;
        else {
            let cherryElement = document.createElement("p");
            cherryElement.innerHTML = "-";
            cherryElement.setAttribute("class", "snake-body");
            nodeChild = cherryElement;
        }
        nextNode.appendChild(nodeChild);
    }
    switch(direction){
        default:
            {
                // right
                // prevCoords[0] = (prevCoords[0] + 1) % boundary  
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    (head[0] + 1) % boundary,
                    head[1]
                ];
                let nextNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $8dd2cf8196daece2$var$COLLISION = (0, $c1aabd7d87053612$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $c1aabd7d87053612$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "<";
                // Extend after head has moved
                if (cherryCoords != null) (0, $c1aabd7d87053612$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "up":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    head[0],
                    (head[1] - 1 + boundary) % boundary
                ];
                let nextNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $8dd2cf8196daece2$var$COLLISION = (0, $c1aabd7d87053612$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $c1aabd7d87053612$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "v";
                if (cherryCoords != null) (0, $c1aabd7d87053612$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "left":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    (head[0] - 1 + boundary) % boundary,
                    head[1]
                ];
                let nextNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $8dd2cf8196daece2$var$COLLISION = (0, $c1aabd7d87053612$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $c1aabd7d87053612$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = ">";
                if (cherryCoords != null) (0, $c1aabd7d87053612$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "down":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    head[0],
                    (head[1] + 1) % boundary
                ];
                let nextNode = $8dd2cf8196daece2$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $8dd2cf8196daece2$var$COLLISION = (0, $c1aabd7d87053612$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $c1aabd7d87053612$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "^";
                if (cherryCoords != null) (0, $c1aabd7d87053612$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
    }
}
function $8dd2cf8196daece2$export$592dbd515a49cf1b() {
    console.log("Starting animation");
    return setInterval($8dd2cf8196daece2$var$animateSnake, 200);
}
function $8dd2cf8196daece2$export$8ae20d19fcabfabc(x, y) {
    let bgItemsX = document.querySelectorAll(`[x=\'${x}\']`);
    for (let node of bgItemsX){
        if (node.getAttribute("y") == y) return node;
    }
}


let $fe8af8a42c4a74bc$var$DIRECTION = "right";
let $fe8af8a42c4a74bc$var$COORDSPRESSED = [];
function $fe8af8a42c4a74bc$export$42b24394061a3314() {
    document.addEventListener("keydown", (event)=>{
        // !Note: Registers when pressed once and held
        const key = event.key;
        if ((key == "ArrowUp" || key.toLowerCase() == "w") && $fe8af8a42c4a74bc$var$DIRECTION !== "down") $fe8af8a42c4a74bc$var$DIRECTION = "up";
        else if ((key == "ArrowDown" || key.toLowerCase() == "s") && $fe8af8a42c4a74bc$var$DIRECTION !== "up") {
            $fe8af8a42c4a74bc$var$DIRECTION = "down";
            console.log($fe8af8a42c4a74bc$var$DIRECTION);
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $fe8af8a42c4a74bc$var$COORDSPRESSED.push([
                x,
                y
            ]);
        } else if ((key == "ArrowRight" || key.toLowerCase() == "d") && $fe8af8a42c4a74bc$var$DIRECTION !== "left") {
            $fe8af8a42c4a74bc$var$DIRECTION = "right";
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $fe8af8a42c4a74bc$var$COORDSPRESSED.push([
                x,
                y
            ]);
        } else if ((key == "ArrowLeft" || key.toLowerCase() == "a") && $fe8af8a42c4a74bc$var$DIRECTION !== "right") {
            $fe8af8a42c4a74bc$var$DIRECTION = "left";
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $fe8af8a42c4a74bc$var$COORDSPRESSED.push([
                x,
                y
            ]);
        }
    });
}
function $fe8af8a42c4a74bc$export$b218224b4df225dd() {
    let bgItems = document.getElementsByClassName("bg-item");
    let randomIndex = Math.floor(Math.random() * 100);
    while(bgItems[randomIndex].children.length > 1)randomIndex = Math.floor(Math.random * 100);
    return randomIndex;
}
function $fe8af8a42c4a74bc$export$f95d126819d028e5(x, y) {
    // ascend in value to the right and down from top left
    // using value of columns and rows
    // top left is 0,0
    return y * 10 + x;
}
function $fe8af8a42c4a74bc$export$59a2245ead134b72(index) {
    return [
        index % 10,
        Math.floor(index / 10)
    ];
}
function $fe8af8a42c4a74bc$export$fcce7887255d1c69() {
    return $fe8af8a42c4a74bc$var$DIRECTION;
}
function $fe8af8a42c4a74bc$export$91c5f51876550773() {
    $fe8af8a42c4a74bc$var$DIRECTION = "right";
}




let $c1aabd7d87053612$var$SNAKEBODYLEN = 3; //
let $c1aabd7d87053612$var$SNAKESTARTCOL = 3;
let $c1aabd7d87053612$var$SNAKESTARTROW = 4;
let $c1aabd7d87053612$var$SNAKEARRAY = [];
let $c1aabd7d87053612$var$cherryCoords = [];
const $c1aabd7d87053612$var$numberOfColsRows = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--number-of-cols-rows"));
function $c1aabd7d87053612$export$74a176e309663b56() {
    return $c1aabd7d87053612$var$SNAKEBODYLEN;
}
function $c1aabd7d87053612$export$1e3d33103e479235() {
    return $c1aabd7d87053612$var$numberOfColsRows;
}
function $c1aabd7d87053612$export$703a176a7b08c13a() {
    //  
    let gameContainer = document.getElementById("game-grid");
    for(let i = 0; i < $c1aabd7d87053612$var$numberOfColsRows ** 2; i++){
        let gridNode = document.createElement("div");
        gridNode.classList.add("bg-item");
        gridNode.setAttribute("x", i % $c1aabd7d87053612$var$numberOfColsRows);
        gridNode.setAttribute("y", Math.floor(i / 10));
        gameContainer.appendChild(gridNode);
    }
    return gameContainer;
}
function $c1aabd7d87053612$export$28c254c05623bf26() {
    let snakeItems = document.getElementsByClassName("snake-body");
    let i = 0;
    for (let snakeItem of snakeItems){
        console.log(snakeItem);
        let parent = snakeItem.parentElement;
        parent.removeChild(snakeItem);
        i++;
        console.log(`${i} nodes removed`);
    }
    let snakeHead = document.getElementsByClassName("snake-head");
    let parent = snakeHead[0].parentElement;
    parent.removeChild(snakeHead[0]);
    let cherries = document.getElementsByClassName("cherry");
    parent = cherries[0].parentElement;
    parent.removeChild(cherries[0]);
    $c1aabd7d87053612$var$SNAKEARRAY = [];
    (0, $fe8af8a42c4a74bc$export$91c5f51876550773)();
    $c1aabd7d87053612$export$5da742abfc97f4db();
}
function $c1aabd7d87053612$export$5da742abfc97f4db() {
    // 
    let snakeBody = "-";
    let snakeHead = "<";
    let snakeRow = $c1aabd7d87053612$var$SNAKESTARTROW;
    let snakeDiv = document.createElement("div");
    snakeDiv.setAttribute("class", "snake-body");
    let snakeItem;
    let bgItems = document.getElementsByClassName("bg-item");
    let currentBgDiv;
    for(let i = $c1aabd7d87053612$var$SNAKESTARTCOL; i < $c1aabd7d87053612$var$SNAKESTARTCOL + $c1aabd7d87053612$var$SNAKEBODYLEN; i++){
        currentBgDiv = bgItems[snakeRow * 10 + i];
        snakeItem = document.createElement("p");
        snakeItem.setAttribute("class", "snake-body");
        snakeItem.innerHTML = snakeBody;
        currentBgDiv.appendChild(snakeItem);
        snakeItem.style.setProperty("grid-column-start", `${i}`);
        $c1aabd7d87053612$var$SNAKEARRAY.push([
            i,
            $c1aabd7d87053612$var$SNAKESTARTROW
        ]);
    }
    currentBgDiv = bgItems[snakeRow * 10 + ($c1aabd7d87053612$var$SNAKEBODYLEN + $c1aabd7d87053612$var$SNAKESTARTCOL)];
    snakeItem = document.createElement("p");
    snakeItem.setAttribute("class", "snake-body");
    snakeItem.setAttribute("class", "snake-head");
    snakeItem.innerHTML = snakeHead;
    currentBgDiv.appendChild(snakeItem);
    snakeItem.style.setProperty("grid-column-start", $c1aabd7d87053612$var$SNAKEBODYLEN + $c1aabd7d87053612$var$SNAKESTARTCOL);
    $c1aabd7d87053612$var$SNAKEARRAY.push([
        $c1aabd7d87053612$var$SNAKEBODYLEN + $c1aabd7d87053612$var$SNAKESTARTCOL,
        $c1aabd7d87053612$var$SNAKESTARTROW
    ]);
    return snakeDiv;
}
function $c1aabd7d87053612$export$fad2c0902020cda5(newTail) {
    $c1aabd7d87053612$var$SNAKEARRAY.unshift(newTail);
}
function $c1aabd7d87053612$export$d13a71bbf24bf677() {
    let bgItems = document.getElementsByClassName("bg-item");
    let curIndex = (0, $fe8af8a42c4a74bc$export$b218224b4df225dd)();
    let cherry = document.createElement("p");
    cherry.setAttribute("class", "cherry");
    cherry.innerHTML = "*";
    bgItems[curIndex].appendChild(cherry);
    $c1aabd7d87053612$var$cherryCoords = (0, $fe8af8a42c4a74bc$export$59a2245ead134b72)(curIndex);
}
function $c1aabd7d87053612$export$30e2d9bef0818dc5() {
    let head = document.getElementsByClassName("snake-head")[0];
    let headX = head.parentElement.getAttribute("x");
    let headY = head.parentElement.getAttribute("y");
    let tailX, tailY;
    // TODO: check direction until a turn event ???
    let lastDir = (0, $fe8af8a42c4a74bc$export$fcce7887255d1c69)() ? (0, $fe8af8a42c4a74bc$export$fcce7887255d1c69)() : "right";
    if (lastDir == "right") {
        tailX = headX - $c1aabd7d87053612$var$SNAKEBODYLEN % 10;
        if (tailX < 0) tailX = $c1aabd7d87053612$var$numberOfColsRows + tailX;
        tailY = headY; // won't always be true 
    } else console.log("NOT YET HANDLED");
    return [
        [
            parseInt(headX),
            parseInt(headY)
        ],
        [
            parseInt(tailX),
            parseInt(tailY)
        ]
    ];
}
function $c1aabd7d87053612$export$be10b7418aab95c7() {
    return $c1aabd7d87053612$var$SNAKEARRAY ? $c1aabd7d87053612$var$SNAKEARRAY : [];
}
function $c1aabd7d87053612$export$da03f46e1126061b() {
    return $c1aabd7d87053612$var$cherryCoords;
}
function $c1aabd7d87053612$export$a9b309f044870c05(head) {
    if (head[0] == $c1aabd7d87053612$var$cherryCoords[0] && head[1] == $c1aabd7d87053612$var$cherryCoords[1]) {
        let oldCherryCoords = $c1aabd7d87053612$var$cherryCoords;
        (0, $b68ed25d6bf54029$export$6c65d967fa3ec93)();
        $c1aabd7d87053612$export$d13a71bbf24bf677();
        return oldCherryCoords;
    }
    return;
}
function $c1aabd7d87053612$export$5528767febabf72a(head) {
    for (let coord of $c1aabd7d87053612$var$SNAKEARRAY)if (head[0] === coord[0] && head[1] === coord[1]) {
        console.log("GAME OVER");
        (0, $b68ed25d6bf54029$export$96d6c2d129a1da1d)();
        return true;
    }
    return false;
}





(0, $b68ed25d6bf54029$export$96d6c2d129a1da1d)();
let $85a5f86b715fe7db$var$gameBoard = (0, $c1aabd7d87053612$export$703a176a7b08c13a)();
let $85a5f86b715fe7db$var$initialSnake = (0, $c1aabd7d87053612$export$5da742abfc97f4db)();
$85a5f86b715fe7db$var$gameBoard.appendChild($85a5f86b715fe7db$var$initialSnake);
(0, $c1aabd7d87053612$export$d13a71bbf24bf677)();
// Start game
// Define and register collision, inputs, sideeffects
(0, $fe8af8a42c4a74bc$export$42b24394061a3314)();
(0, $8dd2cf8196daece2$export$592dbd515a49cf1b)();


//# sourceMappingURL=index.07741e2f.js.map
